/**
 * Each pack's source system: its logo, and its brand colour for the card's
 * accent. The logos belong to their owners and are shown only to identify the
 * system a pack connects to.
 */
export const PACK_BRANDS = {
  hubspot: { logo: '/logos/hubspot.svg', color: '#FF7A59' },
  clickup: { logo: '/logos/clickup.svg', color: '#7B68EE' },
  intacct: { logo: '/logos/sage.svg', color: '#00A82D' },
  sage50: { logo: '/logos/sage.svg', color: '#00A82D' },
  sage200: { logo: '/logos/sage.svg', color: '#00A82D' },
  halo: { logo: '/logos/halo.svg', color: '#002D5B' },
  jira: { logo: '/logos/jira.svg', color: '#0052CC' },
  sagehr: { logo: '/logos/sage.svg', color: '#00A82D' },
  simpro: { logo: '/logos/simpro.svg', color: '#4E4E4F' },
  shopify: { logo: '/logos/shopify.svg', color: '#7AB55C' },
  quickbooks: { logo: '/logos/quickbooks.svg', color: '#2CA01C' },
  xero: { logo: '/logos/xero.svg', color: '#13B5EA' },
};

const DEFAULT_COLOR = '#2889C6';

export const packColor = (id) => PACK_BRANDS[id]?.color || DEFAULT_COLOR;
